import { defineComponent as t, openBlock as n, createBlock as o, unref as r, mergeProps as d, withCtx as p, createElementVNode as e } from "vue";
import { RevIcon as i } from "@ds/components/Icon";
const u = /* @__PURE__ */ t({
  name: "IconReassuranceShieldFilled",
  __name: "IconReassuranceShieldFilled",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(l) {
    const c = l;
    return (m, a) => (n(), o(r(i), d(c, { "view-box": "0 0 48 48" }), {
      default: p(() => [...a[0] || (a[0] = [
        e("g", {
          "fill-rule": "evenodd",
          "clip-path": "url(#cb2b9d73-bf14-48a3-b59c-a777172f8617a)",
          "clip-rule": "evenodd"
        }, [
          e("path", { d: "M12.584 9.769 10.16 23.516c-.96 5.447 1.693 9.764 4.662 12.761a26.7 26.7 0 0 0 6.033 4.522l.003.002h.004a16 16 0 0 0 .451-.071 26.7 26.7 0 0 0 6.764-2.116c3.816-1.8 7.785-4.95 8.745-10.396l2.425-13.752c-2.82.601-4.924.363-6.873-.459-1.758-.74-3.378-1.957-5.255-3.367l-.834-.625q-.551.162-1.077.32c-2.247.669-4.18 1.245-6.067 1.34-2.11.104-4.15-.387-6.557-1.906m15.93 12.096c-.303.83-.892 1.383-1.287 1.235-.396-.148-.481-.949-.168-1.777s.892-1.384 1.286-1.226.482.94.17 1.768m2.556 2.54c-.42-.073-.602-.87-.412-1.73.191-.86.685-1.49 1.112-1.404.427.085.602.871.41 1.74-.193.87-.657 1.495-1.11 1.395m-8.21-2.428a.33.33 0 0 1 .423.163 13.4 13.4 0 0 0 1.168 2.169 9 9 0 0 0 1.583 1.77 9.23 9.23 0 0 0 4.386 2.011.32.32 0 1 1-.063.637 8.2 8.2 0 0 1-2.627-.463 8.1 8.1 0 0 1-3.328-2.285 7.5 7.5 0 0 1-.784-1.12 6.9 6.9 0 0 1-.912-2.566.34.34 0 0 1 .183-.311l-.029-.005" }),
          e("path", { d: "M10.666 4.045a24 24 0 1 1 26.668 39.91 24 24 0 0 1-26.668-39.91m15.578 4.94a.5.5 0 0 1 .437.079q.55.409 1.058.79c1.883 1.414 3.388 2.543 5.023 3.232 1.885.794 3.958 1.004 6.986.236a.5.5 0 0 1 .615.572l-.492-.087.492.087-2.556 14.497c-1.04 5.902-5.345 9.26-9.303 11.128A27.7 27.7 0 0 1 21 41.79l-.128.017-.035.004-.012.001-.058-.496-.224.447-.003-.002-.008-.004-.031-.016-.115-.06a17 17 0 0 1-.425-.233 27.7 27.7 0 0 1-5.85-4.468c-3.08-3.11-5.976-7.736-4.936-13.638l2.557-14.498.492.087-.492-.087a.5.5 0 0 1 .776-.325c2.54 1.749 4.54 2.257 6.583 2.155 1.756-.087 3.552-.622 5.801-1.29q.649-.195 1.352-.4m-5.477 32.332.057.496a.5.5 0 0 1-.28-.05l.223-.446" })
        ], -1),
        e("defs", null, [
          e("clipPath", { id: "cb2b9d73-bf14-48a3-b59c-a777172f8617a" }, [
            e("path", { d: "M0 0h48v48H0z" })
          ])
        ], -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  u as default
};
